import './index.css'

const NavBar = props => {
  const {timeLimit, score} = props

  return (
    <nav>
      <ul className="navConatiner">
        <li>
          <img
            src="https://assets.ccbp.in/frontend/react-js/match-game-website-logo.png"
            alt="website logo"
            className="logoImg"
          />
        </li>
        <li className="scoreContainer">
          <p>
            Score: <span className="score">{score}</span>
          </p>
          <div className="timerContainer">
            <img
              src="https://assets.ccbp.in/frontend/react-js/match-game-timer-img.png"
              alt="timer"
              className="timerLogo"
            />
            <p className="score">{timeLimit} Sec</p>
          </div>
        </li>
      </ul>
    </nav>
  )
}

export default NavBar
